import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateSolicitudGastosOrtopedia = () => {
  const [loadingCreateSolicitudGastosOrtopedia, setLoadingCreateSolicitudGastosOrtopedia] = useState(false);
  const [successCreateSolicitudGastosOrtopedia, setSuccessCreateSolicitudGastosOrtopedia] = useState(false);
  const [errorCreateSolicitudGastosOrtopedia, setErrorCreateSolicitudGastosOrtopedia] = useState(null);
  const [dataCreateSolicitudGastosOrtopedia, setDataSolicitudGastosOrtopedia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const createSolicitudGastosOrtopedia = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudGastosOrtopedia(true);
    setSuccessCreateSolicitudGastosOrtopedia(false);
    setErrorCreateSolicitudGastosOrtopedia(null);

    try {
      const payload = {
        ...data,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.newSolicitudGastosContingenciaProfesionalOrtopedia(userId, payload);

      setSuccessCreateSolicitudGastosOrtopedia(true);
      setDataSolicitudGastosOrtopedia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en createSolicitudGastosOrtopedia:", err);
      setErrorCreateSolicitudGastosOrtopedia(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingCreateSolicitudGastosOrtopedia(false);
    }
  };

  return {
    createSolicitudGastosOrtopedia,
    loadingCreateSolicitudGastosOrtopedia,
    successCreateSolicitudGastosOrtopedia,
    errorCreateSolicitudGastosOrtopedia,
    dataCreateSolicitudGastosOrtopedia
  };
};

export default useCreateSolicitudGastosOrtopedia;
